/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateServiceproviderRequestOther
 */
export interface CreateServiceproviderRequestOther {
    /**
     * 
     */
    hEmail?: string;
}

/**
 * Check if a given object implements the CreateServiceproviderRequestOther interface.
 */
export function instanceOfCreateServiceproviderRequestOther(value: object): value is CreateServiceproviderRequestOther {
    return true;
}

export function CreateServiceproviderRequestOtherFromJSON(json: any): CreateServiceproviderRequestOther {
    return CreateServiceproviderRequestOtherFromJSONTyped(json, false);
}

export function CreateServiceproviderRequestOtherFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateServiceproviderRequestOther {
    if (json == null) {
        return json;
    }
    return {
        
        'hEmail': json['hEmail'] == null ? undefined : json['hEmail'],
    };
}

export function CreateServiceproviderRequestOtherToJSON(json: any): CreateServiceproviderRequestOther {
    return CreateServiceproviderRequestOtherToJSONTyped(json, false);
}

export function CreateServiceproviderRequestOtherToJSONTyped(value?: CreateServiceproviderRequestOther | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'hEmail': value['hEmail'],
    };
}

